// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"styles_Spinner__-P0fl","SpinnerContainer":"styles_SpinnerContainer__hD5p6"};